import React from 'react';
import './Custombutton.css';
import cv from '../assets/images/CV.pdf';

const Custombutton = () => (
  <div>
    <a className="fancy" href={cv} target="_blank" rel="noreferrer">
      <span className="top-key" />
      <span className="text">Download CV</span>
      <span className="bottom-key-1" />
      <span className="bottom-key-2" />
    </a>
  </div>
);

export default Custombutton;
